<template>
    <v-dialog v-model="_value" persistent max-width="600px">
        <v-card height="100%">
            <v-parallax dark class="blue-grey darken-4" height="70">
                <v-container>
                    <v-layout>
                        <h4 class="subheading font-weight-medium">ADD MOTORCYCLE</h4>
                    </v-layout>
                </v-container>
            </v-parallax> 
        
            <v-card-text>
                <v-container grid-list-md class="pt-0">
                    <v-layout wrap>
                        <v-flex xs12>
                            <v-flex xs12 sm12 md12>
                                <v-select v-model="dealer" label="Dealer/Store*" required
                                    :items="dealers" hide-details
                                ></v-select>
                            </v-flex>

                            <v-flex xs12 sm12 md12>
                                <v-select v-model="classification" label="Classification*" required
                                    :items="classifications" hide-details
                                ></v-select>
                            </v-flex>

                            <v-flex xs12 sm12 md12>
                                <v-select v-model="make" label="Make/Brand*" required
                                    :items="brands" hide-details
                                ></v-select>
                            </v-flex>
                        
                            <v-flex xs12 sm12 md12>
                                <v-combobox v-model="model" label="Model*" required
                                    :items="models" hide-details
                                ></v-combobox>
                            </v-flex>

                            <v-flex xs12 sm12 md12>
                                <v-menu ref="yearModelMenu" :close-on-content-click="false" v-model="yearModelMenu" :nudge-right="40" lazy transition="scale-transition" offset-y full-width min-width="290px">
                                    <v-text-field slot="activator" v-model="yearModel" label="Year Model" readonly hide-details placeholder="Optional"></v-text-field>
                                    <v-date-picker ref="picker" :max="new Date().toISOString().substr(0, 10)" v-model="yearModel" @input="save" reactive no-title></v-date-picker>
                                </v-menu>
                            </v-flex>

                            <v-flex xs12 sm12 md12>
                                <v-text-field label="Plate Number" v-model="plateNumber" hide-details placeholder="Optional"
                                ></v-text-field>
                            </v-flex>

                            <v-flex xs12 sm12 md12 class="pb-4">
                                <v-text-field label="Mileage (KM)" mask="#######" v-model="odometer" hide-details placeholder="Optional"
                                ></v-text-field>
                            </v-flex>

                            <v-layout justify-center>
                                <v-card-actions>
                                    <v-spacer></v-spacer>
                                    <v-btn dark color="grey darken-1" @click="cancel()">Close</v-btn>
                                    <v-btn dark color="blue darken-4" @click="saveMotorcycleDetails()">Save</v-btn>
                                </v-card-actions>
                            </v-layout>
                        </v-flex>
                    </v-layout>
                </v-container>
            </v-card-text>
        </v-card>
    </v-dialog>

    <!-- <v-dialog v-model="progressDialog" persistent width="300">
        <v-card color="blue-grey darken-4">
            <v-card-text class="subheading white--text"> Loading...
                <v-layout row justify-center>
                <v-progress-linear :indeterminate="true" :size="70" :width="5" color="white"
                ></v-progress-linear>
                </v-layout>
            </v-card-text>
        </v-card>
    </v-dialog>

    <v-snackbar v-model="showAlert" bottom right :color="alertColor">{{alertMessage}}
        <v-btn dark small flat @click="showAlert = false">Close</v-btn>
    </v-snackbar> -->
</template>

<script>
import "../../node_modules/firebaseui/dist/firebaseui.css"
import { mapGetters, mapActions, mapState } from "vuex"
import { db } from '../main.js'
import _ from 'lodash'

export default {
    props: {
        show: {
            type: Boolean,
            default: false
        },
    },
    model: {
        prop: 'show',
        event: 'change'
    },
	data: () => ({
        materialMaster: [],
        dealers: [],
        brands: [],
        models: [],
        dealer: "",
        make: "",
        model: "",
        yearModel: null,
        yearModelMenu: false,
        odometer: "",
        plateNumber: "",
        progressDialog: false,
        showAlert: false,
        alertColor: "",
        alertMessage: "",
        motorcycleHistoryDialog: false,
        classification: "",
        classifications: ['CUB', 'Automatic','Business','Hi-End'],
        mcColor: "",
    }),
 
    methods : {
        async fetchNsMc() {
            let self = this
            self.materialMaster = []
            await db.collection("Motorcycles").get().then(function(querySnapshot){
                querySnapshot.forEach(function(doc) {
                    self.materialMaster.push(doc.data())
                })
            }).catch(function(error) {
                console.log(error)
            })
        },

        save(date) {
            this.$refs.yearModelMenu.save(date)
            this.$refs.picker.activePicker = "YEAR"
            this.yearModelMenu = false
        },

        refresh(){
            let self = this
            self.classification = ""
            self.dealer = ""
            self.make = ""
            self.model = ""
            self.yearModel = ""
            self.odometer = ""
            self.plateNumber = ""
            // self.progressDialog = false
        },

        cancel() {
            let self = this
            self._value = false
            self.refresh()
            // self.$store.dispatch("setMotorcycle", false)
        },

        saveMotorcycleDetails(){
            let self = this
            if (self.dealer === "" || self.dealer === null) {
                self.alertColor = "red accent-4"
                self.alertMessage = "Dealer should not be blank"
                self.showAlert = true
            } else if (self.make === "" || self.make === null) {
                self.alertColor = "red accent-4"
                self.alertMessage = "Make/Brand should not be blank"
                self.showAlert = true
            } else if (self.model === "" || self.model === null) {
                self.alertColor = "red accent-4"
                self.alertMessage = "Model should not be blank"
                self.showAlert = true
            } else if (self.classification === "") {
                self.alertColor = "red accent-4"
                self.alertMessage = "Classification should not be blank"
                self.showAlert = true
            } else {
                // self.progressDialog = true
                let timeStampId = new Date().getTime().toString()
                let tempFullName = ""
                let tempMobile = ""
                if (self.user.mobileNumber) {
                    tempMobile = self.user.mobileNumber
                } else {
                    tempMobile = self.mobileNumber
                }
                if (self.user.fullName) {
                    tempFullName = self.user.fullName
                } else {
                    tempFullName = `${self.firstName} ${self.lastName}`
                }
                let mcPayload = {
                    "owner": tempFullName,
                    "email": self.user.email,
                    "mobile": tempMobile,
                    "dealer": self.dealer,
                    "make": self.make,
                    "classification": self.classification,
                    "color": "",
                    "model": self.model,
                    "yearModel": self.yearModel,
                    "engineNumber": "",
                    "chassisNumber": "",
                    "plateNumber": self.plateNumber,
                    "odometer": self.odometer,
                    "dateOfPurchase": "",
                    "registrationDate": "",
                    "transactions": [],
                    "status": "1",
                    "id": timeStampId
                }
                db.collection("McDetails"+self.$stage).doc(timeStampId).set(mcPayload).then(function(res) {
                    self.refresh()
                    // self.$store.dispatch("setMotorcycle", false)
                    self._value = false
                }).catch(error => console.log(error))
            }
        },

        fetchDealers() {
            let self = this
            self.dealers = []
            
            db.collection("Settings"+self.$stage).doc("Dealers")
            .collection("Items").get().then(function(querySnapshot){
                querySnapshot.forEach(function(doc) {
                    self.dealers.push(doc.data().dealer)
                })
            }).catch(function(error) {
                console.log(error)
            })
        },
    },

    mounted() {
        this.fetchNsMc()
        this.fetchDealers()
    },

    watch: {
        yearModelMenu (val) {
            val && this.$nextTick(() => (this.$refs.picker.activePicker = "YEAR"))
        },

        yearModel (val) {
            let self = this
            if (val !== ""){
                self.yearModel = val.split('-')[0].trim()
            }
        },

        classification(val) {
            let self = this
            self.brands = []
            self.models = []
            self.make = ""
            self.model = ""
            self.materialMaster.forEach(function(res) {
                if (res.classification === val) {
                    self.brands.push(res.brand)
                }
            })
        },
        make(val) {
            let self = this
            self.models = []
            self.model = ""
            self.materialMaster.forEach(function(res) {
                if (res.brand === val && res.classification === self.classification) {
                    self.models.push(res.model)
                }
            })
        }, 
    },

    computed : {
        ...mapGetters(["user","appointment"]),
        ...mapState(["Auth","Scheduler"]),
        _value: {
            get: function () {
                return this.show
            },
            set: function (newVal) {
                this.$emit('change', newVal)
            }
        }
    }
}

</script>